// extracted by mini-css-extract-plugin
module.exports = {"background":"Header_background__1kk26","text":"Header_text__2J5Yi","x-button":"Header_x-button__3jsWT"};